import { createAction, props } from '@ngrx/store';
import { ClientSummary } from 'app/shared/clients/models/client-summary.model';
import { Client } from 'app/shared/clients/models/client.model';

export const setCurrentClient = createAction('[Client] Set Client', props<{ client: Client }>());

export const setClientLocked = createAction(
  '[Client] Set Client Locked state',
  props<{ isClientLocked: boolean }>()
);

export const setCurrentClientSummary = createAction(
  '[Client] Set Client Summary',
  props<{ clientSummary: ClientSummary }>()
);
